import { render, staticRenderFns } from "./liveCom.vue?vue&type=template&id=efcfce6c&scoped=true&"
import script from "./liveCom.vue?vue&type=script&lang=ts&"
export * from "./liveCom.vue?vue&type=script&lang=ts&"
import style0 from "./liveCom.vue?vue&type=style&index=0&id=efcfce6c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efcfce6c",
  null
  
)

export default component.exports